import React from "react";
import "../Dashboard.css";

export default function IconPreview({ onBack }) {
  const card = (title, content) => (
    <div style={{
      border: "1px solid #e5e7eb",
      borderRadius: 10,
      padding: 16,
      width: 220,
      background: "#fff"
    }}>
      <div style={{ marginBottom: 10, fontWeight: 600 }}>{title}</div>
      <div style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
        <span className="hdr-tip" aria-hidden="true">
          <span className="hdr-tip-icon" style={{ width: 24, height: 24 }}>
            {content}
          </span>
        </span>
        <span style={{ color: "#666" }}>Tooltip icon sample</span>
      </div>
    </div>
  );

  return (
    <div style={{ padding: 24 }}>
      <button
        onClick={onBack || (() => (window.location.search = ""))}
        style={{
          marginBottom: 16,
          padding: "8px 12px",
          borderRadius: 8,
          border: "1px solid #d0d6e0",
          background: "#fff",
          cursor: "pointer",
        }}
      >
        ← Back
      </button>

      <h2 style={{ margin: 0 }}>Robot Tooltip Icon Options</h2>
      <p style={{ color: "#546072", marginTop: 6 }}>
        Below are four drop-in options. Tell me which you prefer and I will apply it everywhere.
      </p>

      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginTop: 12 }}>
        {card(
          "Option 1 — Outline robot",
          (
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <rect x="5" y="8" width="14" height="10" rx="2" fill="none" stroke="#333" strokeWidth="2" />
              <circle cx="9" cy="13" r="1.5" fill="#333" />
              <circle cx="15" cy="13" r="1.5" fill="#333" />
              <line x1="12" y1="6" x2="12" y2="8" stroke="#333" strokeWidth="2" />
              <circle cx="12" cy="5" r="1" fill="#333" />
            </svg>
          )
        )}

        {card(
          "Option 2 — Filled robot",
          (
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <rect x="5" y="8" width="14" height="10" rx="2" fill="#333" />
              <circle cx="9" cy="13" r="1" fill="#fff" />
              <circle cx="15" cy="13" r="1" fill="#fff" />
              <line x1="12" y1="6" x2="12" y2="8" stroke="#333" strokeWidth="2" />
              <circle cx="12" cy="5" r="1" fill="#333" />
            </svg>
          )
        )}

        {card(
          "Option 3 — Friendly rounded",
          (
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <rect x="5" y="8" width="14" height="10" rx="3" fill="none" stroke="#333" strokeWidth="1.8" />
              <circle cx="9" cy="13" r="1.3" fill="#333" />
              <circle cx="15" cy="13" r="1.3" fill="#333" />
              <path d="M10.5 16.5h3" stroke="#333" strokeWidth="1.8" />
              <line x1="12" y1="6" x2="12" y2="8" stroke="#333" strokeWidth="1.8" />
              <circle cx="12" cy="5" r="1" fill="#333" />
            </svg>
          )
        )}

        {card(
          "Option 4 — Emoji robot",
          (
            <span style={{ fontSize: 18 }} role="img" aria-label="robot">🤖</span>
          )
        )}
      </div>
    </div>
  );
}


